// @generated by protoc-gen-es v1.10.0
// @generated from file fingertip/creator/event_type/v1/event_type.proto (package fingertip.creator.event_type.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { BoolValue, Int32Value, proto3, StringValue, Timestamp } from "@bufbuild/protobuf";
import { AttendanceType } from "../../../common/enum/v1/attendance_type_pb.js";
import { EventType } from "../../../common/type/v1/event_type_pb.js";
import { PageInfo } from "../../../common/type/v1/page_info_pb.js";
import { EventTypeSchedule } from "../../../common/type/v1/event_type_schedule_pb.js";
import { PeriodType } from "../../../common/enum/v1/period_type_pb.js";
import { SchedulingType } from "../../../common/enum/v1/scheduling_type_pb.js";
import { EventLocation } from "../../../common/type/v1/event_location_pb.js";
import { Media } from "../../../common/type/v1/media_pb.js";

/**
 * @generated from message fingertip.creator.event_type.v1.GetEventTypesRequest
 */
export const GetEventTypesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.event_type.v1.GetEventTypesRequest",
  () => [
    { no: 1, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "include_archived", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "include_hidden", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "attendance_type", kind: "enum", T: proto3.getEnumType(AttendanceType) },
  ],
);

/**
 * @generated from message fingertip.creator.event_type.v1.GetEventTypesResponse
 */
export const GetEventTypesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.event_type.v1.GetEventTypesResponse",
  () => [
    { no: 1, name: "event_types", kind: "message", T: EventType, repeated: true },
    { no: 2, name: "total", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "page_info", kind: "message", T: PageInfo },
  ],
);

/**
 * @generated from message fingertip.creator.event_type.v1.GetEventTypesPublicRequest
 */
export const GetEventTypesPublicRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.event_type.v1.GetEventTypesPublicRequest",
  () => [
    { no: 3, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.event_type.v1.GetEventTypesPublicResponse
 */
export const GetEventTypesPublicResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.event_type.v1.GetEventTypesPublicResponse",
  () => [
    { no: 1, name: "event_types", kind: "message", T: EventType, repeated: true },
    { no: 2, name: "total", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "event_type_schedules", kind: "message", T: EventTypeSchedule, repeated: true },
  ],
);

/**
 * @generated from message fingertip.creator.event_type.v1.GetEventTypePublicRequest
 */
export const GetEventTypePublicRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.event_type.v1.GetEventTypePublicRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "event_type_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.event_type.v1.GetEventTypePublicResponse
 */
export const GetEventTypePublicResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.event_type.v1.GetEventTypePublicResponse",
  () => [
    { no: 1, name: "event_type", kind: "message", T: EventType },
  ],
);

/**
 * @generated from message fingertip.creator.event_type.v1.GetEventTypeRequest
 */
export const GetEventTypeRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.event_type.v1.GetEventTypeRequest",
  () => [
    { no: 1, name: "event_type_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.event_type.v1.GetEventTypeResponse
 */
export const GetEventTypeResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.event_type.v1.GetEventTypeResponse",
  () => [
    { no: 1, name: "event_type", kind: "message", T: EventType },
    { no: 2, name: "active_bookings_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "active_group_class_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message fingertip.creator.event_type.v1.CreateEventTypeRequest
 */
export const CreateEventTypeRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.event_type.v1.CreateEventTypeRequest",
  () => [
    { no: 1, name: "length", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "metadata", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "schedule_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "hidden", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "position", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "period_type", kind: "enum", T: proto3.getEnumType(PeriodType) },
    { no: 11, name: "period_start_date", kind: "message", T: Timestamp },
    { no: 12, name: "period_end_date", kind: "message", T: Timestamp },
    { no: 13, name: "period_days", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 14, name: "period_count_calendar_days", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 15, name: "requires_confirmation", kind: "message", T: BoolValue },
    { no: 16, name: "recurring_event", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "disable_guests", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 18, name: "hide_calendar_notes", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 19, name: "minimum_booking_notice", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 20, name: "before_event_buffer", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 21, name: "after_event_buffer", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 22, name: "scheduling_type", kind: "enum", T: proto3.getEnumType(SchedulingType) },
    { no: 25, name: "slot_interval", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 26, name: "success_redirect_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 27, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 28, name: "seats_per_time_slot", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 29, name: "seats_show_attendees", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 30, name: "locations", kind: "message", T: EventLocation, repeated: true },
    { no: 31, name: "price_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 32, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 33, name: "maximum_booking_window", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 35, name: "refundable", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 41, name: "attendance_type", kind: "enum", T: proto3.getEnumType(AttendanceType) },
    { no: 42, name: "max_attendees", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 43, name: "media", kind: "message", T: Media },
    { no: 44, name: "color", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 45, name: "show_attendee_count", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 47, name: "form_template_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 48, name: "is_archived", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 50, name: "disable_reschedule", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.event_type.v1.CreateEventTypeResponse
 */
export const CreateEventTypeResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.event_type.v1.CreateEventTypeResponse",
  () => [
    { no: 1, name: "event_type", kind: "message", T: EventType },
  ],
);

/**
 * @generated from message fingertip.creator.event_type.v1.UpdateEventTypeRequest
 */
export const UpdateEventTypeRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.event_type.v1.UpdateEventTypeRequest",
  () => [
    { no: 1, name: "event_type_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "length", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "metadata", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "schedule_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "hidden", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "position", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "period_type", kind: "enum", T: proto3.getEnumType(PeriodType) },
    { no: 12, name: "period_start_date", kind: "message", T: Timestamp },
    { no: 13, name: "period_end_date", kind: "message", T: Timestamp },
    { no: 14, name: "period_days", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 15, name: "period_count_calendar_days", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 16, name: "requires_confirmation", kind: "message", T: BoolValue },
    { no: 17, name: "recurring_event", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 18, name: "disable_guests", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 19, name: "hide_calendar_notes", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 20, name: "minimum_booking_notice", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 21, name: "before_event_buffer", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 22, name: "after_event_buffer", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 23, name: "scheduling_type", kind: "enum", T: proto3.getEnumType(SchedulingType) },
    { no: 24, name: "slot_interval", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 25, name: "success_redirect_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 26, name: "description", kind: "message", T: StringValue },
    { no: 27, name: "locations", kind: "message", T: EventLocation, repeated: true },
    { no: 28, name: "price_in_cents", kind: "message", T: Int32Value },
    { no: 29, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 30, name: "maximum_booking_window", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 32, name: "refundable", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 34, name: "seats_per_timeslot", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 39, name: "attendance_type", kind: "enum", T: proto3.getEnumType(AttendanceType) },
    { no: 40, name: "max_attendees", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 41, name: "media", kind: "message", T: Media },
    { no: 42, name: "color", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 43, name: "show_attendee_count", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 45, name: "form_template_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 46, name: "is_archived", kind: "message", T: BoolValue },
    { no: 49, name: "disable_reschedule", kind: "message", T: BoolValue },
  ],
);

/**
 * @generated from message fingertip.creator.event_type.v1.UpdateEventTypeResponse
 */
export const UpdateEventTypeResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.event_type.v1.UpdateEventTypeResponse",
  () => [
    { no: 1, name: "event_type", kind: "message", T: EventType },
  ],
);

/**
 * @generated from message fingertip.creator.event_type.v1.UpdateEventTypesOrderRequestItem
 */
export const UpdateEventTypesOrderRequestItem = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.event_type.v1.UpdateEventTypesOrderRequestItem",
  () => [
    { no: 1, name: "event_type_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "position", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message fingertip.creator.event_type.v1.UpdateEventTypesOrderRequest
 */
export const UpdateEventTypesOrderRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.event_type.v1.UpdateEventTypesOrderRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "items", kind: "message", T: UpdateEventTypesOrderRequestItem, repeated: true },
  ],
);

/**
 * @generated from message fingertip.creator.event_type.v1.UpdateEventTypesOrderResponse
 */
export const UpdateEventTypesOrderResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.event_type.v1.UpdateEventTypesOrderResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.event_type.v1.DeleteEventTypeRequest
 */
export const DeleteEventTypeRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.event_type.v1.DeleteEventTypeRequest",
  () => [
    { no: 1, name: "event_type_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.event_type.v1.DeleteEventTypeResponse
 */
export const DeleteEventTypeResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.event_type.v1.DeleteEventTypeResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.event_type.v1.GetEventTypeScheduleRequest
 */
export const GetEventTypeScheduleRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.event_type.v1.GetEventTypeScheduleRequest",
  () => [
    { no: 1, name: "event_type_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "range_start", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "range_end", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "client_time_zone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "event_types", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 5 /* ScalarType.INT32 */} },
    { no: 6, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "custom_length", kind: "message", T: Int32Value },
  ],
);

/**
 * @generated from message fingertip.creator.event_type.v1.TimeSlotGroupClassInfo
 */
export const TimeSlotGroupClassInfo = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.event_type.v1.TimeSlotGroupClassInfo",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "available", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "max", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "waitlist_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.event_type.v1.TimeSlot
 */
export const TimeSlot = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.event_type.v1.TimeSlot",
  () => [
    { no: 1, name: "time", kind: "message", T: Timestamp },
    { no: 2, name: "group_class", kind: "message", T: TimeSlotGroupClassInfo },
  ],
);

/**
 * @generated from message fingertip.creator.event_type.v1.DaySlots
 */
export const DaySlots = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.event_type.v1.DaySlots",
  () => [
    { no: 1, name: "slots", kind: "message", T: TimeSlot, repeated: true },
  ],
);

/**
 * @generated from message fingertip.creator.event_type.v1.GetEventTypeScheduleResponse
 */
export const GetEventTypeScheduleResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.event_type.v1.GetEventTypeScheduleResponse",
  () => [
    { no: 1, name: "slots_by_day", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: DaySlots} },
  ],
);

